const SizesUtils = require('../../../viscomjs/utils/SizesUtils');

function ViewportsResizeBehaviour(vps, refEl, ratio) {

    const r = ratio || 1;

    return {
        resize: () => {
            const rect1 = refEl.getBoundingClientRect();
            const dy = SizesUtils.getWinScrollTop();
            let w = Math.round(rect1.width * r);
            if (w % 2 > 0)
                w--;
            let h = Math.round(rect1.height * r);
            if (h % 2 > 0)
                h--;

            vps.forEach(el => {
                el.style.width = `${w}px`;
                el.style.height = `${h}px`;
                el.style.top = `${Math.round(dy + rect1.top)}px`;
                el.style.left = `${Math.round(rect1.left)}px`;
            });
        },
        clear: () => {
            vps.forEach(el => {
                el.style.width = '';
                el.style.height = '';
                el.style.top = '';
                el.style.left = '';
            });
        }
    };
}

module.exports = ViewportsResizeBehaviour;


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/behaviors/ViewportsSyncTopResizeBehaviour.js